import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Storage } from '@ionic/storage-angular';
import { Company } from 'src/app/interfaces/company';
import { CompanyService } from 'src/app/services/company.service';
import { ToastService } from 'src/app/services/toast.service';

import iro from '@jaames/iro';//Quelle https://www.npmjs.com/package/@jaames/iro
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss'],
})
export class CompanyComponent implements OnInit {
  company: any;
  primaryColor: string = "";
  secondaryColor: string = "";
  colorPicker2: any;
  colorPicker: any;
  colors: any[];

  constructor(
    private storage: Storage,
    private companyservice: CompanyService,
    private tsService: ToastService
  ) {

  }

  async ngOnInit() {
    this.company = await this.storage.get(environment.storage.company);
    console.log("---COMPANY----", this.company);
    // this.changeColor1();
    // this.changeColor2();

  }

  // async ionViewWillEnter() {
  //   this.company = await this.storage.get(environment.storage.company);
  //   console.log("---COMPANY----", this.company);
  //   this.changeColor1();
  //   this.changeColor2();

  // }

  save() {
    this.companyservice.updateCompany(this.company).subscribe(x => {
      console.log('Update COMPANY_KEY', x);
      this.tsService.addToast();
      if (this.company) {
        this.colors = [this.company.primary_color, this.company.secondary_color]
        let root = document.documentElement;
        if (this.colors[0] != undefined) {
          root.style.setProperty('--ion-color-primary', this.colors[0]);
        } else {
          root.style.setProperty('--ion-color-primary', 'grey');
        }
        if (this.colors[1] != undefined) {
          root.style.setProperty('--ion-color-secondary', this.colors[1]);
        } else {
          root.style.setProperty('--ion-color-secondary', 'goldenrod');
        }
      }
    }, err => {
      console.log('ERROR Company Put', err);
      this.tsService.addToastNot();
    });
  }
  // Firmenfarbe 1
  changeColor1() {
    if (this.colorPicker)
    return;
    this.colorPicker = iro.ColorPicker("#picker", {
      width: 100,
      color: this.company.primary_color
    });
    this.colorPicker.on('color:change', color => {
      this.company.primary_color = color.hexString;
    });
  }
  
  // Firmenfarbe 2
  changeColor2() {
    if (this.colorPicker2)
      return;
    this.colorPicker2 = iro.ColorPicker("#picker2", {
      width: 100,
      color: this.company.secondary_color
    });
    this.colorPicker2.on('color:change', color => {
      this.company.secondary_color = color.hexString;
    });
  }

  changeInput(event) {
    this.colorPicker.on('color:change', color => {
      this.company.primary_color = event.detail.target.value;
    });
    console.log('COLOR EVENT:', event.detail.target.value);
    console.log('COLOR EVENT2:', this.colorPicker2);
  }

  changeInput2(event) {
    this.colorPicker2.on('color:change', color => {
      this.company.secondary_color = event.detail.target.value;
    });
    console.log('COLOR EVENT:', event.detail.target.value);
    console.log('COLOR EVENT2:', this.colorPicker2);
  }
  // buttonClick() {
  //   let colorPicker = iro.ColorPicker("#picker", {
  //     width: 320,
  //     color: "#fff"
  //   })
  //   colorPicker.on('color:change', color => {
  //     this.colorcode = color.hexString;
  //   })
  // }

}
